<template>
  <div
    :id="id"
    class="accordion"
  >
    <div
      v-for="(item, index) in items"
      :key="index"
      class="--card"
    >
      <div
        id="headingOne"
        class="--card-header"
      >
        <hr>
        <div class="mb-0">
          <a
            href="#"
            class="d-block px-4 py-1"
            data-toggle="collapse"
            :data-target="'#item'+index"
            aria-expanded="true"
            @click="$emit('change-current-tab', index)"
          ><slot
            name="header"
            :item="item"
          >{{ item }}</slot></a>
        </div>
      </div>

      <div
        :id="'item'+index"
        class="collapse"
        :class="{show: index == open}"
        :data-parent="'#'+id"
      >
        <hr>
        <div class="p-4">
          <slot :index="index" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    name: 'BaseAccordion',
    props: {
        id: {
            type: String,
            default: 'AccordionID',
        },
        open: {
            type: Number,
            default: null,
        },
        items: {
            type: Array,
            default() {
                return [];
            },
        },
    },
};
</script>
